<script>
    import MBaseFormElement from "@/assets/plugins/mps-form/providers/MBaseFormElement";

    export default {
        name: "MBaseFormCheckbox",
        extends: MBaseFormElement,
        data() {
            return {
                innerModel: this.model || false,
            }
        },
        computed: {
        },
        watch: {
            innerModel() {
                this.model = this.innerModel;
            },

            model() {
                this.innerModel = this.model;
            },
        },
        created() {
            this.$emit("input", this.innerModel);
        },
        methods: {
        }
    }
</script>